import { useState, useEffect } from 'react'
import { Row, Col, Image } from 'react-bootstrap'
import { toast } from 'react-toastify'
import api from '../../../services/api'
import { Warning, HandPalm } from 'phosphor-react'
//import Gauge from "../../../assets/VehicleInfo/'alert'-icons/Gauge.svg";
import SpeedingGauge from '../../../assets/VehicleInfo/alert-icons/SpeedingGauge.svg'
import { errorApi } from '../../../utils/errorApi'

import styles from './styles.module.css'
import { useLoading } from '../../../hooks/LoadingContext'

function DriverAlerts({ driverId, handleShowTickets, date = '' }) {
  const [alertsInfo, setAlertsInfo] = useState({})

  const { setIsLoading } = useLoading()

  useEffect(() => {
    setIsLoading(true)
    async function loadData() {
      try {
        const alertsData = await api.get(`/company/drivers/${driverId}/alerts?date=${date}`)
        setAlertsInfo(alertsData.data)
      } catch (err) {
        toast.error(
          errorApi(
            err,
            'Falha ao buscar as estatísticas do motorista. Tente novamente mais tarde.',
          ),
        )
      }
      setIsLoading(false)
    }
    loadData()
  }, [driverId, date, setIsLoading])

  return (
    <div>
      <Row>
        <Col className={`${styles.alertContainer} col-12 col-md-5 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Warning
                style={{ marginTop: 10, marginBottom: 10 }}
                color="#FFC700"
                size={50}
                weight="light"
              />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Atividades suspeitas</span>
              <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                {alertsInfo.suspicious_activities + ' registros'}
              </span>
            </Col>
          </Row>
        </Col>
        <Col
          onClick={handleShowTickets}
          className={`${styles.alertContainer} ${styles.cardClickable} col-12 col-md-5 offset-md-1 border cursor-pointer`}
          style={{ cursor: 'pointer' }}
        >
          <Row>
            <Col className="col-4 text-center">
              <HandPalm
                style={{ marginTop: 10, marginBottom: 10 }}
                color="#DB222A"
                size={50}
                weight="light"
              />{' '}
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Infrações de trânsito</span>
              <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                {alertsInfo.traffic_violations + ' registros'}
              </span>
              <span style={{ fontSize: 10 }}>Clique aqui</span>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row>
        <Col className={`${styles.alertContainer} col-12 col-md-5 border`}>
          <Row>
            <Col className="col-4 text-center">
              <Image style={{ marginTop: 10, marginBottom: 10 }} width={50} src={SpeedingGauge} />
            </Col>
            <Col className="col-8 text-center d-flex flex-column align-items-center justify-content-center">
              <span style={{ fontSize: 12 }}>Excesso de velocidade</span>
              <span style={{ fontSize: 18, fontWeight: 'bold' }}>
                {alertsInfo.speeding + ' registros'}
              </span>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default DriverAlerts
